import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "~/ssrAdapter/react-router-dom";
import { TestimonialCarousel } from "~/components/Marketing";
import { FrequentlyAskedQuestions, PricingBrandsBanner, PricingHero } from "~/components/Pricing";
import Zendesk from "~/components/Zendesk";
import { PLANS } from "~/constants";
import featureFlags from "~/constants/featureFlags";
import analytics from "~/services/analytics";
import usePageTrack from "~/services/analytics/usePageTrack";
import { localeSelectors } from "~/services/locale";
import { signupActions } from "~/services/signup";
import { loginActions } from "~/services/login";
var Pricing = function(param) {
    var planType = param.planType;
    var dispatch = useDispatch();
    var history = useHistory();
    var currency = useSelector(localeSelectors.getCurrency);
    usePageTrack({
        name: analytics.events.PRICING,
        category: analytics.events.category.MARKETING,
        currency: currency
    });
    var onChoosePlan = useCallback(function(param) {
        var plan = param.plan, planInterval = param.planInterval, source = param.source;
        analytics.track(analytics.events.PRICING_TABLE_SIGNUP_CLICKED, {
            plan: plan,
            planInterval: planInterval,
            source: source
        });
        if (plan === PLANS.BUSINESS) {
            history.push("/contact-sales");
            return;
        }
        if (plan !== PLANS.FREE && featureFlags.signupPricingRedirect) {
            dispatch(signupActions.setPostSignupRedirectUrl({
                url: "/plan/confirm/".concat(plan, "/").concat(planInterval)
            }));
            dispatch(loginActions.setPostLoginRedirectUrl({
                url: "/plan/confirm/".concat(plan, "/").concat(planInterval)
            }));
        }
        history.push("/signup");
    }, [
        dispatch,
        history
    ]);
    return /*#__PURE__*/ _jsxs("main", {
        role: "main",
        children: [
            /*#__PURE__*/ _jsx(Zendesk, {}),
            /*#__PURE__*/ _jsx(PricingHero, {
                onChoosePlan: onChoosePlan,
                planType: planType
            }),
            /*#__PURE__*/ _jsx(PricingBrandsBanner, {}),
            /*#__PURE__*/ _jsx(TestimonialCarousel, {}),
            /*#__PURE__*/ _jsx(FrequentlyAskedQuestions, {})
        ]
    });
};
Pricing.propTypes = {
    planType: PropTypes.string
};
export default Pricing;
